import { UseQueryResult } from "@tanstack/react-query";

import { RainRaster, RasterAggregateResult } from "../types/rasterRain";
import { getMaxValueForBarchartInMm } from "../utils/rainRasterHelper";

import RainBarChart, { RainDataPoint } from "./RainBarChart";
import styles from "./RainMenuRasterPreview.module.css";

interface Props {
  selectedRasterAggregateQueryResult: UseQueryResult<RasterAggregateResult | undefined, unknown>;
  rainRaster: RainRaster;
}

const RainMenuRasterPreview: React.FC<Props> = ({
  selectedRasterAggregateQueryResult,
  rainRaster,
}) => {
  const hasData = !!(
    selectedRasterAggregateQueryResult.data &&
    selectedRasterAggregateQueryResult.data.results &&
    selectedRasterAggregateQueryResult.data.results.find(
      (item: RainDataPoint) => item.value !== null
    )
  );
  return (
    <div className={styles.RainBarContainer}>
      <h2 className={styles.PreviewHeader}>
        {"This graph shows the aggregated rainfall per time step for the model extent"}
      </h2>
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "grid",
            visibility: hasData ? "hidden" : "visible",
          }}
        >
          <span style={{ placeSelf: "center", alignSelf: "center" }}>
            {!hasData &&
            selectedRasterAggregateQueryResult.data &&
            selectedRasterAggregateQueryResult.data.message ===
              "Too many timesteps requested #400.23"
              ? "Please choose shorter timeframe"
              : !hasData &&
                selectedRasterAggregateQueryResult.data &&
                selectedRasterAggregateQueryResult.data.message === "Resource not found. #404.10"
              ? "Preview not available for raster"
              : !hasData &&
                selectedRasterAggregateQueryResult.data &&
                selectedRasterAggregateQueryResult.data.results &&
                !selectedRasterAggregateQueryResult.data.results.find(
                  (item: RainDataPoint) => item.value !== null
                )
              ? "No data in given timeframe"
              : !hasData &&
                selectedRasterAggregateQueryResult.data &&
                selectedRasterAggregateQueryResult.data.message
              ? selectedRasterAggregateQueryResult.data.message
              : !hasData
              ? "No data"
              : ""}
          </span>
        </div>
        <RainBarChart
          rainBarChartData={
            hasData &&
            selectedRasterAggregateQueryResult.data &&
            selectedRasterAggregateQueryResult.data.results
              ? selectedRasterAggregateQueryResult.data.results
              : []
          }
          chartTop={
            hasData
              ? getMaxValueForBarchartInMm(
                  (selectedRasterAggregateQueryResult.data &&
                    selectedRasterAggregateQueryResult.data.results) ||
                    [],
                  rainRaster
                )
              : 1
          }
          showsData={hasData}
        />
      </div>
    </div>
  );
};

export default RainMenuRasterPreview;
